import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CalendarPlus, Phone, ExternalLink, Mail } from "lucide-react";

export default function BookButton({ property, rule, contractors, onDone }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(null);
  const matches = contractors.filter((c) => c.trade === rule.category || c.trade === "general");
  const book = async (c) => {
    setBusy(c.id);
    try {
      const { data } = await api.post(`/properties/${property.id}/book/${c.id}`, { rule_name: rule.name });
      if (data.emailed) toast.success(`Booking request emailed to ${c.name}`);
      else { toast.info("Opening your email app with the request pre-filled"); window.location.href = data.mailto; }
      if (data.booking_url) window.open(data.booking_url, "_blank", "noreferrer");
      setOpen(false); onDone && onDone();
    } catch { toast.error("Could not send booking request"); } finally { setBusy(null); }
  };
  return (
    <>
      <button data-testid={`book-${rule.id}`} onClick={() => setOpen(true)} className="inline-flex items-center gap-1 text-xs px-2 min-h-[30px] rounded-lg bg-navy/5 hover:bg-navy/10 text-navy font-medium"><CalendarPlus size={12} /> Book</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-card max-w-md" data-testid="book-modal">
          <DialogHeader><DialogTitle className="font-heading text-base">Book: {rule.name}</DialogTitle></DialogHeader>
          <p className="text-xs text-muted-foreground">We'll email your contractor the property address and ask them to send the certificate to your email-in address, so it files itself.</p>
          <div className="space-y-2 mt-2">
            {matches.map((c) => (
              <div key={c.id} className="flex items-center gap-3 p-3 rounded-xl border border-border">
                <div className="flex-1 min-w-0"><div className="font-semibold text-sm">{c.name}</div><div className="text-xs text-muted-foreground truncate">{c.email || c.phone || c.booking_url}</div></div>
                {c.phone && <a href={`tel:${c.phone}`} className="p-2 rounded-lg hover:bg-secondary" aria-label="Call"><Phone size={15} /></a>}
                {c.booking_url && <a href={c.booking_url} target="_blank" rel="noreferrer" className="p-2 rounded-lg hover:bg-secondary" aria-label="Open booking site"><ExternalLink size={15} /></a>}
                <button data-testid={`book-with-${c.id}`} disabled={busy === c.id} onClick={() => book(c)} className="min-h-[36px] px-3 inline-flex items-center gap-1 rounded-lg bg-emerald-brand hover:bg-emerald-deep text-white text-xs font-semibold disabled:opacity-60"><Mail size={13} /> {busy === c.id ? "Sending…" : "Request"}</button>
              </div>
            ))}
            {matches.length === 0 && <p className="text-sm text-muted-foreground" data-testid="no-contractors">No matching contractor saved yet. <Link to="/settings" className="text-emerald-brand underline">Add one in Settings</Link>.</p>}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
